import { IfcProfileDef } from "./ifc4_gen/index.js";
/**
 * IFC model profile cache.
 */
export class IfcModelProfile {
    /**
     * Construct this with its parent model.
     *
     * @param model The model for this.
     */
    constructor(model) {
        this.model = model;
        this.profiles_ = new Map();
    }
    /**
     * Get the number of profiles in this.
     *
     * @return {number}
     */
    get length() {
        return this.profiles_.size;
    }
    /**
     * Add a profile to the cache.
     *
     * @param profile
     */
    add(profile) {
        this.profiles_.set(profile.localID, profile);
    }
    /**
     * Get a profile by its local id.
     *
     * @param localID
     * @return {CanonicalProfile | undefined}
     */
    getByLocalID(localID) {
        return this.profiles_.get(localID);
    }
    /**
     * Iterate through the profiles in this.
     *
     * @return {IterableIterator}
     */
    [Symbol.iterator]() {
        return this.profiles_.values();
    }
    /**
     * Get the OBJs for all the curves in the cache (lazily)
     *
     * @yields {[IfcProfileDef, string]} Curves with their matching OBJ as a string
     */
    *objs() {
        const model = this.model;
        for (const [localID, profile] of this.profiles_) {
            const profileItem = model.getElementByLocalID(localID);
            const nativeProfile = profile.nativeProfile;
            if (!(profileItem instanceof IfcProfileDef) || nativeProfile === void 0) {
                continue;
            }
            const objFileContents = nativeProfile.dumpToOBJ("");
            yield [profileItem, objFileContents];
        }
    }
}
